import apiClient from '../utils/apiClient';

class ExpenseService {
  // Get all expenses for a restaurant
  async getExpenses(restaurantId, options = {}) {
    const { page, limit, from, to, category } = options;
    const params = new URLSearchParams();
    params.append('restaurant', restaurantId);
    
    if (page) params.append('page', page);
    if (limit) params.append('limit', limit);
    if (from) params.append('from', from);
    if (to) params.append('to', to);
    if (category) params.append('category', category);
    
    const response = await apiClient.get(`/expenses?${params.toString()}`);
    return response;
  }

  // Get single expense
  async getExpense(expenseId, populateFields = false) {
    const url = populateFields 
      ? `/expenses/${expenseId}?populateFields=true`
      : `/expenses/${expenseId}`;
    const response = await apiClient.get(url);
    return response;
  }

  // Create new expense
  async createExpense(restaurantId, expenseData) {
    const response = await apiClient.post('/expenses', {
      ...expenseData,
      restaurant: restaurantId
    });
    return response;
  }

  // Update expense
  async updateExpense(restaurantId, expenseId, expenseData) {
    const response = await apiClient.patch(`/expenses/${expenseId}`, expenseData);
    return response;
  }

  // Delete expense
  async deleteExpense(restaurantId, expenseId) {
    const response = await apiClient.delete(`/expenses/${expenseId}`);
    return response;
  }

  // Get expense statistics
  async getExpenseStats(restaurantId, period = 'month') {
    const response = await apiClient.get(`/restaurants/${restaurantId}/expenses/stats?period=${period}`);
    return response;
  }

  // Get expenses by category
  async getExpensesByCategory(restaurantId, category, period = 'month') {
    const response = await apiClient.get(
      `/restaurants/${restaurantId}/expenses/category/${category}?period=${period}`
    );
    return response;
  }

  // Get expenses by date range
  async getExpensesByDateRange(restaurantId, startDate, endDate) {
    const response = await apiClient.get(
      `/restaurants/${restaurantId}/expenses/date-range?start=${startDate}&end=${endDate}`
    );
    return response;
  }

  // Get short-lived receipt download URL
  async getReceiptUrl(expenseId, options = {}) {
    const { disposition = 'inline' } = options;
    const params = new URLSearchParams();
    if (disposition) {
      params.append('disposition', disposition);
    }
    const query = params.toString();
    const url = query
      ? `/expenses/${expenseId}/receipt-url?${query}`
      : `/expenses/${expenseId}/receipt-url`;
    const response = await apiClient.get(url);
    return response;
  }

  // Get expense categories
  async getExpenseCategories(restaurantId) {
    const response = await apiClient.get(`/restaurants/${restaurantId}/expenses/categories`);
    return response;
  }

  // Get monthly expense summary
  async getMonthlyExpenseSummary(restaurantId, year, month) {
    const response = await apiClient.get(
      `/restaurants/${restaurantId}/expenses/monthly-summary?year=${year}&month=${month}`
    );
    return response;
  }

  // Get expense trends
  async getExpenseTrends(restaurantId, period = 'year') {
    const response = await apiClient.get(`/restaurants/${restaurantId}/expenses/trends?period=${period}`);
    return response;
  }
}

const expenseService = new ExpenseService();
export default expenseService;
